import styled from "styled-components";
import { provideIsLoadingProp, } from "@/utils/context/LoadingContext";
import { THEME } from "@core/theme";
const { skeletonBase } = THEME;
export const CheckoutSectionSpan = styled.span.attrs(provideIsLoadingProp) `
  display: block;
  ${({ isLoading }) => isLoading && skeletonBase + "height: auto;"};
`;
